import { styled } from '@vebox/etui-system';
import { Children, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { H5 } from '../H5/H5.js';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '../Icon/InfoGlyph.js';
import InfoIcon from '../Icon/InfoIcon.js';
import { animated, Trail } from 'react-spring/renderprops.cjs';
import { H3 } from '../H3/H3.js';

const _excluded = ["theme"];
const EmptyStateDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    minHeight: '100%',
    width: '100%',
    color: theme.palette.text.disabled
  }, props);
})``;

const _excluded$1 = ["opacity"];
function EmptyState({
  children,
  animationDelay = 0,
  styles = {}
}) {
  const result = Children.map(children, child => function Wrapper(_ref) {
    let {
        opacity
      } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded$1);
    return /*#__PURE__*/createElement(animated.div, {
      style: _objectSpread2({
        opacity
      }, rest)
    }, child);
  });
  return /*#__PURE__*/createElement(EmptyStateDiv, styles.root, /*#__PURE__*/createElement(Trail, {
    reset: true,
    native: true,
    items: result,
    keys: result.map((_, i) => i),
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
    // eslint-disable-next-line react/no-children-prop
    ,
    children: child => child,
    delay: animationDelay
  }));
}
EmptyState.displayName = 'EmptyState';
EmptyState.Icon = Icon;
EmptyState.InfoIcon = InfoIcon;
EmptyState.Title = H3;
EmptyState.SubTitle = H5;

export default EmptyState;
